import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { homeForRole, useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Wordmark";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) return setError("Passwords do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser(data);
      toast.success("Password updated");
      navigate(homeForRole(data.role), { replace: true });
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-white flex flex-col" data-testid="change-password-page">
      <header className="px-5 sm:px-10 h-16 border-b border-zinc-800/70 flex items-center"><Wordmark className="text-2xl" /></header>
      <main className="flex-1 flex items-center justify-center px-5">
        <form onSubmit={submit} data-testid="change-password-form" className="w-full max-w-md border border-zinc-800 bg-zinc-950 p-8 sm:p-10">
          <p className="text-[10px] uppercase tracking-[0.25em] text-volt font-bold">Required security step</p>
          <h1 className="font-display uppercase text-5xl leading-none mt-3">Change your password</h1>
          <p className="text-sm text-zinc-400 mt-4">Signed in as {user?.email}. Choose a new password before continuing.</p>
          <input data-testid="current-password-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required
            placeholder="Current temporary password" className="mt-8 w-full bg-ink border border-zinc-700 px-4 py-4 text-sm focus:border-volt outline-none" />
          <input data-testid="new-password-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={10}
            placeholder="New password" className="mt-4 w-full bg-ink border border-zinc-700 px-4 py-4 text-sm focus:border-volt outline-none" />
          <input data-testid="confirm-new-password-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={10}
            placeholder="Confirm new password" className="mt-4 w-full bg-ink border border-zinc-700 px-4 py-4 text-sm focus:border-volt outline-none" />
          {error && <p data-testid="change-password-error" className="mt-4 text-sm text-red-400">{error}</p>}
          <button data-testid="change-password-submit" disabled={busy}
            className="mt-7 w-full bg-volt text-black uppercase tracking-[0.18em] text-xs font-extrabold py-4 hover:bg-white disabled:opacity-50 transition-colors">
            {busy ? "Updating…" : "Save and continue"}
          </button>
        </form>
      </main>
    </div>
  );
}
